module.exports = __webpack_public_path__ + "static/media/impulse.a0914bae.png";